import { Container, Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { NoDataOverlay } from 'components/index';

import { useGetSupportTickets } from 'hooks';
import { ScrollAreaLayout } from 'layout';
import useChatTable from 'pages/activity-page/useChatTable';
import TicketingTable from 'pages/ticketing-page/TicketingTable';

function TicketingPage() {
  const { supportTickets, isLoading, error } = useGetSupportTickets();
  const {
    chatData,
    sortModel,
    onSortModelChange,
    projectNames,
    assigneeOptions,
    isImportantFilter,
    setIsImportantFilter,
    selectedLabels,
    setSelectedLabels,
    selectedProjectNames,
    setSelectedProjectNames,
    selectedAssignees,
    setSelectedAssignees,
    selectedStatuses,
    setSelectedStatuses,
    showArchived,
    setShowArchived,
    userLabels,
    filteredChatData,
    projectName,
  } = useChatTable(supportTickets);

  if (error) {
    return (
      <NoDataOverlay
        text='Error Loading Tickets, Please Reload the Page'
        onClick={() => {
          window.location.reload();
        }}
        buttonTitle='Reload'
      />
    );
  }

  return (
    <>
      <Container maxWidth='lg'>
        <Stack>
          <ScrollAreaLayout subtract={0}>
            <TicketingTable
              projectName={projectName}
              isLoading={isLoading}
              chatData={chatData}
              sortModel={sortModel}
              onSortModelChange={onSortModelChange}
              projectNames={projectNames}
              assigneeOptions={assigneeOptions}
              isImportantFilter={isImportantFilter}
              setIsImportantFilter={setIsImportantFilter}
              selectedLabels={selectedLabels}
              setSelectedLabels={setSelectedLabels}
              selectedProjectNames={selectedProjectNames}
              setSelectedProjectNames={setSelectedProjectNames}
              selectedAssignees={selectedAssignees}
              setSelectedAssignees={setSelectedAssignees}
              selectedStatuses={selectedStatuses}
              setSelectedStatuses={setSelectedStatuses}
              showArchived={showArchived}
              setShowArchived={setShowArchived}
              userLabels={userLabels}
              filteredChatData={filteredChatData}
            />
          </ScrollAreaLayout>
        </Stack>
      </Container>
      <Outlet />
    </>
  );
}

export default TicketingPage;
